import React, { useState } from 'react'
import { firestore } from '../../../firebase';

function LeaguesAPI() {

    const [leagueId, setLeagueId] = useState("");
    const [leagueLogo, setLeagueLogo] = useState("");
    const [leagueName, setLeagueName] = useState("");
    const [order, setOrder] = useState(1);
    const [error, setError] = useState("");

    async function addLeagueHandler(e) {
        e.preventDefault();
        try {
            const topLeaguesRef = firestore.collection("top-leagues");
            const data = {
                league_id: leagueId,
                league_logo: leagueLogo,
                league_name: leagueName,
                order
            }
            topLeaguesRef.add(data);
        } catch (error) {
            setError(error.message)
        }
    }

    return (
        <div>
            <h2 className="text-center font-weight-bold my-2">Legg til liga</h2>
            <form onSubmit={addLeagueHandler}>
                <label>Liganavn</label>
                <input className="form-control mb-2" value={leagueName} onChange={e => setLeagueName(e.target.value)} placeholder="Liganavn" />
                <label>Liga logo</label>
                <input className="form-control mb-2" value={leagueLogo} onChange={e => setLeagueLogo(e.target.value)} placeholder="Liga logo" />
                <label>Liga ID</label>
                <input className="form-control mb-2" value={leagueId} onChange={e => setLeagueId(e.target.value)} placeholder="Liga ID" />
                <label>Rangering</label>
                <input className="form-control mb-2" value={order} onChange={e => setOrder(e.target.value)} type="number" />
                {error && <div className="alert alert-danger">{error}</div>}
                <button className="btn btn-success btn-rounded">Legg til liga</button>
            </form>
        </div>
    )

}
export default LeaguesAPI